import ztComponent from './ztSlider.vue'
import ztComponentItem from './ztSliderItem.vue'
export default (Vue) => {
  Vue.component(ztComponent.name, ztComponent)
  Vue.component(ztComponentItem.name, ztComponentItem)
}
